import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../design/tokens';
import { SocialSettings } from '../../types';
import { FiSave, FiFileText } from 'react-icons/fi';

const Section = styled.section`
  background: ${tokens.colors.adminSurface};
  border-radius: 12px;
  padding: ${tokens.spacing.lg};
  margin-bottom: ${tokens.spacing.lg};
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${tokens.spacing.lg};
  padding-bottom: ${tokens.spacing.sm};
  border-bottom: 1px solid ${tokens.colors.adminBorder};
`;

const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${tokens.colors.adminText};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.md};
`;

const LegalForm = styled.div`
  padding: ${tokens.spacing.lg};
`;

const FormGroup = styled.div`
  margin-bottom: ${tokens.spacing.xl};
`;

const FormLabel = styled.label`
  display: block;
  font-weight: 600;
  color: ${tokens.colors.adminText};
  margin-bottom: ${tokens.spacing.sm};
`;

const FormTextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: ${tokens.spacing.md};
  border: 1px solid ${tokens.colors.adminBorder};
  border-radius: 6px;
  font-size: 14px;
  background: ${tokens.colors.adminSurface};
  color: ${tokens.colors.adminText};
  font-family: monospace;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: ${tokens.colors.adminAccent};
  }
`;

const FormActions = styled.div`
  display: flex;
  gap: ${tokens.spacing.md};
  justify-content: flex-end;
  margin-top: ${tokens.spacing.xl};
`;

const SaveBtn = styled.button`
  background: ${tokens.colors.adminAccent};
  color: white;
  border: none;
  padding: ${tokens.spacing.md} ${tokens.spacing.xl};
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.sm};
  &:hover {
    background: #7a04b8;
  }
`;

interface AdminLegalSettingsProps {
  settings: Partial<SocialSettings>;
  onUpdate: (settings: Partial<SocialSettings>) => void;
  onSave: () => void;
}

const AdminLegalSettings: React.FC<AdminLegalSettingsProps> = ({ settings, onUpdate, onSave }) => {
  return (
    <Section>
      <SectionHeader>
        <SectionTitle>
          {React.createElement(FiFileText as any, { size: 24 })}
          Páginas Legales
        </SectionTitle>
      </SectionHeader>
      <LegalForm>
        <FormGroup>
          <FormLabel>Política de Privacidad</FormLabel>
          <FormTextArea
            value={settings.privacy_policy_content || ''}
            onChange={(e) => onUpdate({ ...settings, privacy_policy_content: e.target.value })}
            placeholder="Contenido de la política de privacidad..."
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Términos de Uso</FormLabel>
          <FormTextArea
            value={settings.terms_content || ''}
            onChange={(e) => onUpdate({ ...settings, terms_content: e.target.value })}
            placeholder="Contenido de los términos de uso..."
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Ayuda y Soporte</FormLabel>
          <FormTextArea
            value={settings.help_content || ''}
            onChange={(e) => onUpdate({ ...settings, help_content: e.target.value })}
            placeholder="Contenido de la página de ayuda..."
          />
        </FormGroup>

        <FormActions>
          <SaveBtn onClick={onSave}>
            {React.createElement(FiSave as any, { size: 16 })}
            Guardar Cambios
          </SaveBtn>
        </FormActions>
      </LegalForm>
    </Section>
  );
};

export default AdminLegalSettings;
